<template>
  <div class="project-tasks-layout" v-if="isInitLoading">
    <div class="project-tasks-layout__main-content-skeleton">
      <div class="project-tasks-layout__main-skeleton"></div>
      <div class="project-tasks-layout__main-right-skeleton"></div>
    </div>
  </div>
  <div v-if="!taskDetailErrorCode && isUserAccessTask" class="task-detail">
    <div class="task-detail__section">
      <TaskMainDetail
        v-if="!isInitLoading"
        ref="$mainDetail"
        :userAccess="userAccess"
        :editing="editing"
        :edit-task-info="editTaskInfo"
        v-model:form-data="formData"
        :tags="dictionaries.Tags"
        :employees="dictionaries.Users"
        :subtasks="subtasks"
        :ignore-search-subtasks="ignoreSearchSubtasks"
        :timerTrackerRecords="timerTrackerRecords"
        :is-view-all-subtasks="isViewAllSubtasks"
        :count-subtasks="countSubtasks"
        :is-loading-show-all-subtasks="isLoadingShowAllSubtasks"
        :search-tasks-to-attach="searchTasksToAttach"
        :search-tasks-change-parent="searchTasksChangeParent"
        :file-upload-callbak="attachFileFromDescription"
        :is-disable-create-button="!isChanged || isDisabledSubmit"
        :is-loading-create-button="isLoadingCreateButton"
        :is-loading-attach-files-button="isLoadingAttachFiles"
        :files-loading-edit-name="filesLoadingEditName"
        :is-loading-unattach-parent="isLoadingUnattachParent"
        :is-loading-unattach-subtask="isLoadingUnattachSubtask"
        :errors="mainDetailErrors"
        :uploading-files="uploadingFiles"
        :isEstimate="isEstimate"
        @save-task-name="saveTaskName"
        @save-task-observers="saveTaskObservers"
        @save-task-performers="saveTaskPerformers"
        @save-task-tags="saveTaskTags"
        @save-task-description="saveDescription"
        @show-all-subtasks="showAllSubtasks"
        @attach-subtask="isAttachSubtask"
        @remove-subtask="removeSubtask"
        @on-click-create="createTask"
        @attach-files="attachFilesLocal"
        @remove-file="removeFile"
        @update-file-name="updateFileName"
        @attach-parent-task="setParentTask($event, false)"
        @change-parent-task="setParentTask($event, true)"
        @unattach-parent-task="unAttachParentTask"
        @copy-id="copyId"
        @copy-name="copyName"
        @copy-task-link="copyNameAndLinkTask"
        @open-edit-image="openEditImage"
        @created-subtask="getSubtasks"
        @updated-subtask="getSubtasks"
      />
    </div>
    <div
      class="task-detail__section right"
      :class="{
        'task-detail__section-right--fixed': isFixedRightConten,
      }"
    >
      <template v-if="!isInitLoading">
        <div class="task-detail__sidebar">
          <Tabs
            :model-value="currentTabId"
            @update:model-value="setCurrentTab"
            class="task-detail__section-right-tabs"
          >
            <Tab :val="TaskDetailTabEnum.Actions" label="Действия" :current-tab="currentTabId" />
            <Tab
              :val="TaskDetailTabEnum.History"
              label="История изменений"
              :current-tab="currentTabId"
            />
            <Tab
              :val="TaskDetailTabEnum.Comments"
              label="Комментарии"
              :current-tab="currentTabId"
            />
          </Tabs>
          <TirPmScrollbar
            style="max-height: calc(100vh - 12.5rem)"
            v-if="currentTabId === TaskDetailTabEnum.Actions"
          >
            <div class="task-detail__section-right-tabs-content">
              <div class="task-detail__section-right-tabs-content-first">
                <TaskActionsDetail
                  ref="$actionDetail"
                  :userAccess="userAccess"
                  :editing="editing"
                  :is-edit-mode="!!editTaskInfo"
                  :isEstimate="isEstimate"
                  :selected-status="formData.StatusId"
                  :selected-priority="formData.PriorityId"
                  :selected-difficulty="formData.DifficultyId"
                  :selected-type="formData.TypeId"
                  :deadline-date="formData.DeadlineDate"
                  :statuses="dictionaries.Statuses"
                  :priorities="dictionaries.Priorities"
                  :difficulty-list="dictionaries.Difficulties"
                  :type-list="dictionaries.Types"
                  :timer-records="timerTrackerRecords"
                  :timer-start-date="timerStartDate"
                  :is-loading-timer="isLoadingTimerButton"
                  :performers-estimated="editTaskInfo?.PerformersEstimated"
                  :is-loading-estimate="isLoadingEstimate"
                  :is-disabled-timer="!formData?.PerformerIds?.includes(CurrentUser.Id)"
                  :taskId="props.taskId"
                  :canUpsertFinalEstimate="editTaskInfo?.CanUpsertFinalEstimate"
                  :finalEstimatePerformer="editTaskInfo?.FinalEstimatePerformer"
                  :allowStatusChange="allowStatusChange"
                  :isPerformer="isPerformer"
                  @update:selected-status="saveTaskStatus"
                  @update:selected-priority="saveTaskPriority"
                  @update:selected-difficulty="saveTaskDifficulty"
                  @update:selected-type="saveTaskType"
                  @update:deadline-date="saveDeadline"
                  @on-start-timer="startTimer"
                  @on-stop-timer="stopTimer"
                  @on-create-timer-record="createTimerRecord"
                  @on-edit-timer-record="editTimerRecord"
                  @on-delete-timer-record="deleteTimerRecord"
                  @updateTimer="updateTimer"
                />
              </div>
            </div>
          </TirPmScrollbar>
          <HistoryOfChangesList
            v-if="currentTabId === TaskDetailTabEnum.History"
            :taskId="props.taskId"
          ></HistoryOfChangesList>
          <TirPmCommentChat
            :projectId="props.projectId"
            :taskId="props.taskId"
            v-if="currentTabId === TaskDetailTabEnum.Comments"
          />
        </div>
      </template>
    </div>
    <TaskCropImageModal
      ref="$cropImageModal"
      :is-loading="isLoadingCropModal"
      :existFileNames="existFileNames"
      @on-close="onCloseCropImageModal"
      @on-confirm="saveImageFromCrop"
    />
    <TaskNoSaveDataModal
      ref="$noSaveDataModal"
      :title="noSaveDataModalTitle"
      @exit="confirmLeave"
      @cancel-exit="cancelLeave"
    />
  </div>
  <TaskDrawer ref="$taskDrawer" @on-create-task="getSubtasks" />
</template>

<script lang="ts" setup>
import {
  computed,
  ComputedRef,
  inject,
  onBeforeMount,
  onMounted,
  onUnmounted,
  PropType,
  ref,
  watch,
} from 'vue';
import TaskMainDetail from './task-main-detail.vue';
import TaskActionsDetail from './task-actions-detail.vue';
import { TirPmCommentChat } from '../comment-chat';
import { AdapterService } from './adapter';
import {
  TaskFormDataModel,
  TaskUpdateStatusModel,
  TaskUpdateDifficultyModel,
  TaskUpdatePriorityModel,
  TaskUpdateTypeModel,
  TaskUpdateDateEndModel,
  TaskModel,
  TaskUpdateNameModel,
  TaskUpdateObserversModel,
  TaskUpdatePerformersModel,
  TaskUpdateTagsModel,
  CreateTaskModel,
  TaskUpdateDescriptionModel,
  GetUserRoleByTaskIdsRequsetModel,
  GetUserRoleByTaskIdsItemModel,
} from './models';
import { Tabs, Tab, TirPmScrollbar } from 'tir-components';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { useFormValidator, FormValidators } from 'tir-pm-form-validation';
import HistoryOfChangesList from '../history-of-changes/HistoryOfChangesList.vue';
import { TirPmNotificationEventBus, TirPmNotificationModel } from 'tir-pm-notification';
import { NavigationGuardNext, onBeforeRouteLeave, useRoute, useRouter } from 'vue-router';
import { useTaskDictionaries, useTaskTimer, useTaskFiles, useTaskSubtasks } from './composables';
import { copyToClipboard } from '../../utils';
import { useTaskFormDataTransfer } from '../../composables';
import { TaskFormDataTransferModel } from '../../models';
import { TaskDetailTabEnum } from './enums';
import { TaskCropImageModal } from '../task-crop-image-modal';
import { TaskNoSaveDataModal } from '../task-no-save-data-modal';
import { ListenTaskInfoAdapter } from './adapter';
import moment from 'moment';
import 'moment-timezone';
import { AccessAdapterService } from './adapter/AccessAdapterService';
import { MiddlewareAdapterService } from '@/router/middleware';
import GetAccessCurrentUserInQueueTaskByIdResponse from '@/pages/task-detail-page/models/GetAccessCurrentUserInQueueTaskByIdResponse';
import EmployeeQueueTaskAccessEnum from '@/layouts/queue-layout/enums/EmployeeQueueTaskAccessEnum';
import { ProjectQueueTaskListItem } from '@/components/tasks-kanban/adapter';
import GetAccessCurrentUserInQueueTaskByIdRequestModel from '@/components/tasks-kanban/models/GetAccessCurrentUserInQueueTaskByIdRequestModel';
import { TaskDrawer, TaskDrawerSettingsModel } from '../task-drawer';

/**Маршруты */
const router = useRouter();
/**Api сервис */
const middlewareService = new MiddlewareAdapterService();

/**Параметры */
const props = defineProps({
  /**информация очереди */
  queueInfo: {
    type: Array as PropType<ProjectQueueTaskListItem[]>,
  },
  /**ID задачи */
  taskId: { type: Number },
  /**ID очереди */
  queueId: { type: String },
  /**ID проекта */
  projectId: { type: Number },
  /**ID неймспейса */
  namespaceId: { type: String },
  /**Оценка задачи */
  isEstimate: { type: Boolean },
  /**Текущий таб */
  tab: { type: Number as PropType<TaskDetailTabEnum>, default: () => TaskDetailTabEnum.Actions },
  /**есть ли онформация о очереди */
  isNoQueueInformation: { type: Boolean },
});

const emit = defineEmits<{
  /**Проверка на доступ к задаче*/
  (e: 'checkIsUserAccessTask', checkIsUserAccessTask: boolean);
  (e: 'updateLoading', isLoading: boolean);
  /**Событие получения кода ошибки */
  (e: 'getErrorCode', errorCode: number);
}>();

/**Ссылка на компонент шторки задач */
const $taskDrawer = ref<InstanceType<typeof TaskDrawer>>();
const editing = ref(true); // TODO: Переделать на считывание из апи
/**Код ошибки при получении детальной информации задачи */
const taskDetailErrorCode = ref<number>();
/**Доступы юзера к род. задаче */
const userAccessToParentTask = ref<GetUserRoleByTaskIdsItemModel>();
/**Канал события */
const channelStopTimer = new BroadcastChannel('task-timers');
/**Время жизни уведомления со статусом успешно */
const NOTIFICATION_SUCCESS_LIFE = 1250;
/**Время жизни уведомления со статусом ошибки */
const NOTIFICATION_ERROR_LIFE = 2000;
/**Добавить уведомление */
const addNotification = (message: string, isSuccess: boolean = true) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isSuccess ? 'success' : 'error',
      group: 'general',
      life: isSuccess ? NOTIFICATION_SUCCESS_LIFE : NOTIFICATION_ERROR_LIFE,
      closable: true,
    }),
  );
};
/**ID последней очереди */
let lastQueueId: string;
/**ID последнего проекта */
let lastProjectId: number;

const adapter = new AdapterService();
const accessAdapter = new AccessAdapterService();
const adapterListen = new ListenTaskInfoAdapter(
  {
    UpdateTaskPriorityFn: changePriority,
    UpdateTaskStatusFn: changeStatus,
    UpdateTaskTypeFn: changeType,
    UpdateTaskDifficultyFn: changeDifficulty,
    UpdateTaskNameFn: changeName,
    UpdateTaskDescriptionFn: changeDescription,
    UpdateTaskObserverFn: changeObserver,
    UpdateTagsInTaskFn: changeTagsInTask,
    UpdateTaskDateEndFn: changeDateEnd,
    UpdateTaskPerformersFn: changePerformer,
    AddTaskFileFn: addTaskFile,
    AddTaskFilesBatchFn: addTaskFilesBatch,
    AddTaskQueueRelationFn: addTaskQueueRelation,
    AttachTaskForParentSubtaskFn: attachTaskSubtask,
    ChangeOrderNumberQueueTaskFn: changeOrderNumberQueueTask,
    RemoveTaskEstimatePerformerFn: removeTaskEstimatePerformer,
    RemoveTaskFilesFn: removeTaskFiles,
    RemoveTaskQueueRelationFn: removeTaskQueueRelation,
    RemoveTaskSubtaskFn: removeTaskSubtask,
    UpdateTaskFileNameFn: updateTaskFileName,
    ListenCompleteAddFileFn: listenCompleteAddFile,
    RemoveTaskFilesEventFn: removeTaskFilesEvent,
  },
  props.taskId,
);
/**Текущий ID таба */
const currentTabId = ref(props.tab);
/**Установить таб */
const setCurrentTab = (tab: number) => {
  router.replace({
    query: {
      ...router.currentRoute.value.query,
      tab,
    },
  });
};
/**Ссылка на компонент виджета действия */
const $actionDetail = ref<InstanceType<typeof TaskActionsDetail>>();
/**Ссылка на основную форму */
const $mainDetail = ref<InstanceType<typeof TaskMainDetail>>();

/**Роут */
const route = useRoute();

/**Доступы юзера к задаче */
const userAccess = ref<GetAccessCurrentUserInQueueTaskByIdResponse>();

/**Загрузка при инициализации */
const isInitLoading = ref(false);
/**Данные формы */
const formData = ref(new TaskFormDataModel());
/**Информация о редактируемой задаче */
const editTaskInfo = ref<TaskModel>();
/**Заголовок модального окна предупреждения при не сохраненных даных */
const noSaveDataModalTitle = computed(() =>
  editTaskInfo.value?.Id ? 'Выйти сейчас?' : 'Отменить создание?',
);

/**Предыдущие данные формы */
const prevFormDataJsonString = ref<string>(JSON.stringify(new TaskFormDataModel()));

watch(
  () => props.tab,
  () => {
    currentTabId.value = props.tab;
  },
);

/**Получение доступов по текущему пользователю в очереди задач по идентификатору */
const getAccessCurrentUserInQueueTask = async () => {
  const queueId = route.params.queueId?.toString();
  const response = await adapter.getAccessCurrentUserInQueueTaskById(
    new GetAccessCurrentUserInQueueTaskByIdRequestModel({
      QueueTaskId: queueId,
    }),
  );
  if (response.IsSuccess) {
    userAccess.value = response.Value;
  }
};

/**
 * * Получить делатьную информаци о задаче
 * @param taskId ID задачи
 */
const getTaskDetail = async (taskId: number) => {
  const resp = await adapter.getTaskDetail(taskId);
  if (resp.IsSuccess) {
    editTaskInfo.value = resp.Value;

    formData.value = new TaskFormDataModel({
      Owner: resp.Value.Owner,
      FolderId: resp.Value.FolderId,
      Name: resp.Value.Name,
      Description: resp.Value.Description,
      StatusId: resp.Value.StatusId,
      TypeId: resp.Value.TypeId,
      PriorityId: resp.Value.PriorityId,
      DifficultyId: resp.Value.DifficultyId,
      Performers: resp.Value.Performers,
      Observers: resp.Value.Observers,
      PerformerIds: resp.Value.PerformerIds,
      ObserverIds: resp.Value.ObserverIds,
      Estimated: resp.Value.Estimated,
      DeadlineDate: resp.Value.DeadlineDate,
      Tags: resp.Value.Tags,
      SubtaskIds: resp.Value.SubtaskIds,
      Files: resp.Value.Files,
      QueueToTaskRelationList: resp.Value.QueueToTaskRelationList,
    });

    prevFormDataJsonString.value = JSON.stringify(formData.value);
    if (editTaskInfo.value.Parent?.Id) await getUserAccessToParentTask();
  } else {
    router.push({
      name: 'project-stub-page',
      query: { errorCode: resp.ErrorCode },
    });
  }

  taskDetailErrorCode.value = resp.ErrorCode;
  return resp.IsSuccess;
};
/**Получить доступы юзера к род. задаче */
const getUserAccessToParentTask = async () => {
  const resp = await adapter.getUserRoleByTaskIdsAsync(
    new GetUserRoleByTaskIdsRequsetModel({
      TaskIds: [editTaskInfo.value.Parent.Id],
    }),
  );
  if (resp.IsSuccess) {
    userAccessToParentTask.value = resp.Value[0];

    editTaskInfo.value.Parent.HasAccessToParentTask =
      userAccessToParentTask.value?.IsAdminNamespace ||
      userAccessToParentTask.value?.IsAdminProject ||
      userAccessToParentTask.value?.IsOwner ||
      userAccessToParentTask.value?.IsPerformer ||
      userAccessToParentTask.value?.IsObserver ||
      userAccessToParentTask.value?.IsAuthor ||
      userAccessToParentTask.value?.VisibilityOtherTask;
  }
};

/**Управление подзадачами */
const {
  isViewAllSubtasks,
  isLoadingShowAllSubtasks,
  isChangedSubtasks,
  isLoadingUnattachParent,
  isLoadingUnattachSubtask,
  subtasks,
  countSubtasks,
  ignoreSearchSubtasks,
  getSubtasks,
  showAllSubtasks,
  attachSubtask,
  removeSubtask,
  setParentTask,
  unAttachParentTask,
  searchTasksToAttach,
  searchTasksChangeParent,
  resetSubtasksData,
} = useTaskSubtasks({
  currentTask: editTaskInfo,
  onSuccessSetParentTask: () => getTaskDetail(editTaskInfo.value.Id),
});

/**Управление файлами */
const {
  openEditImage,
  isLoadingCropModal,
  saveImageFromCrop,
  onCloseCropImageModal,
  $cropImageModal,
  isLoadingAttachFiles,
  filesLoadingEditName,
  uploadingFiles,
  attachFiles,
  attachFileFromDescription,
  updateFileName,
  removeFile,
  resetFilesData,
  existFileNames,
} = useTaskFiles({
  currentTask: editTaskInfo,
  formData: formData,
  projectId: props.projectId,
  queueId: props.queueId,
});

/**Списки */
const { dictionaries, getDictionaries } = useTaskDictionaries();
/**Управление таймером */
const {
  timerStartDate,
  isLoadingTimerButton,
  timerTrackerRecords,
  startTimer,
  stopTimer,
  createTimerRecord,
  editTimerRecord,
  deleteTimerRecord,
  initTimerData,
  resetTimerData,
  getTimerRecords,
} = useTaskTimer({
  taskId: computed(() => props.taskId),
  onSuccessCreateTimerRecord: () => $actionDetail.value?.$timeTracker?.clearInputValue(),
  onSuccessEditTimerRecord: () => $actionDetail.value?.$timeTracker?.clearInputValue(),
  onOpenConfirmStartTimer: () => $actionDetail.value?.$timeTracker?.$startConfrimPopover?.open(),
});

/**Сбросить данные */
const reset = () => {
  resetSubtasksData();
  resetFilesData();
  resetTimerData();

  prevFormDataJsonString.value = JSON.stringify(new TaskFormDataModel());
  formData.value = new TaskFormDataModel();
  editTaskInfo.value = undefined;
};

/**Обновить таймер */
const updateTimer = async (state: boolean) => {
  timerStartDate.value = !state ? new Date() : undefined;
  if (state) await getTimerRecords();
};

/**Имеется ли возможность просматривать задачи */
const isViewTask = computed(() =>
  userAccess.value?.EmployeeQueueTaskAccesses.includes(
    EmployeeQueueTaskAccessEnum.VisibilityOtherTask,
  ),
);

/**Является ли текущий юзер исполнителем задачи */
const isCurrentUserPerformerTask = computed(() => {
  return editTaskInfo.value?.Performers.some((performer) => performer.Id == CurrentUser.Id);
});

/**Является ли текущий юзер автором задачи */
const isCurrentUserAvtorTask = computed(() => {
  return editTaskInfo.value?.Owner.Id == CurrentUser.Id;
});
/**Является ли текущий юзер наблюдателем задачи */
const isCurrentUserObserverTask = computed(() => {
  return editTaskInfo.value?.ObserverIds.includes(CurrentUser.Id);
});
/**Был ли приглашен юзер */
const isInvited = inject<ComputedRef<boolean>>('isInvited');

/**Проверка на доступ юзера к задаче */
const isUserAccessTask = computed(() => {
  return (
    userAccess.value?.IsOwner ||
    isCurrentUserPerformerTask.value ||
    isViewTask.value ||
    userAccess.value?.IsProjectAdmin ||
    userAccess.value?.IsNamespaceAdmin ||
    isCurrentUserAvtorTask.value ||
    isCurrentUserObserverTask.value ||
    isInvited?.value
  );
});

/**Изменены ли данные в форме */
const isChanged = computed(() => {
  const firstJson = JSON.parse(prevFormDataJsonString.value);
  const secondJson = JSON.parse(JSON.stringify(formData.value));
  firstJson.DeadlineDate = undefined;
  secondJson.DeadlineDate = undefined;

  return JSON.stringify(firstJson) !== JSON.stringify(secondJson) || isChangedSubtasks.value;
});
/**Доступен ли выход */
const isAllowExit = computed(() => {
  // Если режим редактирования
  if (editTaskInfo.value?.Id) {
    // Описание не сохранено
    const isNoSaveDescription = $mainDetail.value?.$editor?.isChangedValue;
    return !isNoSaveDescription;
  } else {
    return !isChanged.value;
  }
});
/**Разрешено редактирование статуса */
const allowStatusChange = computed(() => {
  const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);
  const isObserver = formData.value?.ObserverIds?.includes(CurrentUser.Id);
  const isAuthor = formData.value?.Owner?.Id == CurrentUser.Id;

  return (
    isOwner || isPerformer.value || isObserver || isAuthor || userAccess.value.IsNamespaceAdmin
  );
});
/**Пользователь является исполнителем задачи */
const isPerformer = computed(() => formData.value?.PerformerIds?.includes(CurrentUser.Id));
/**Загрузка в компоненте оценки */
const isLoadingEstimate = ref(false);

/**При успешном редактирование */
const onSuccessEdit = () => {
  if (editTaskInfo.value) {
    editTaskInfo.value.DateUpdate = new Date();
  }
};
/**При не успешном редактировании */
const onFailEdit = async (taskId: number) => {
  await getTaskDetail(taskId);
};

/**Прикрепить файлы */
const attachFilesLocal = async (files: Array<File>, fromDescription: boolean = false) => {
  if (fromDescription) await saveDescription();
  await attachFiles(files);
};

/**Успешное создание задачи */
const onSuccessCreateTask = async (taskId: number) => {
  addNotification('Задача успешно создана');

  router.replace({
    name: 'task-detail',
    params: {
      taskId,
    },
  });
};
/**Загрузка кнопки создания */
const isLoadingCreateButton = ref(false);

/**Создание задачи */
const createTask = async () => {
  if (editTaskInfo.value || !StartValidate()) {
    addNotification(
      "Заполните все обязательные для заполнения поля (<span style='color: red; font-size: 1.5rem'>*</span>)",
      false,
    );
    return;
  }
  StopValidate();

  const request = new CreateTaskModel({
    ...formData.value,
    QueueId: props.queueId,
    ProjectId: props.projectId,
  });

  isLoadingCreateButton.value = true;
  const resp = await adapter.createTask(request);
  if (resp.IsSuccess) {
    await onSuccessCreateTask(resp.Value);
  }
  isLoadingCreateButton.value = false;
};

const isAttachSubtask = async (value) => {
  await attachSubtask(value);
  const scrollToLastElement = $mainDetail.value.$taskRelations.scrollToLastElement;
  const subtaskElement = $mainDetail.value.$taskRelations.subtaskElement;
  scrollToLastElement(subtaskElement);
};

/**Сохранить теги */
const saveTaskTags = async (tagIds: Array<number>) => {
  formData.value.Tags = tagIds;
  if (tagIds === undefined || !editTaskInfo.value?.Id) return;
  const request = new TaskUpdateTagsModel({
    Id: editTaskInfo.value.Id,
    Tags: tagIds,
  });
  const resp = await adapter.updateTaskTags(request);
  if (resp.IsSuccess) {
    onSuccessEdit();
  } else {
    onFailEdit(request.Id);
    addNotification('Произошла ошибка при обновлении тегов', false);
  }
};
/**Сохранить исполнителей */
const saveTaskPerformers = async (performerIds: Array<number>) => {
  formData.value.PerformerIds = performerIds;
  if (performerIds === undefined || !editTaskInfo.value?.Id) return;
  const request = new TaskUpdatePerformersModel({
    Id: editTaskInfo.value.Id,
    PerformerIds: performerIds,
  });
  const resp = await adapter.updateTaskPerformers(request);
  if (resp.IsSuccess) {
    onSuccessEdit();
  } else {
    onFailEdit(request.Id);
    addNotification('Произошла ошибка при обновлении списка исполнителей', false);
  }
};
/**Сохранить наблюдателей */
const saveTaskObservers = async (observerIds: Array<number>) => {
  formData.value.ObserverIds = observerIds;
  if (observerIds === undefined || !editTaskInfo.value?.Id) return;
  const request = new TaskUpdateObserversModel({
    Id: editTaskInfo.value.Id,
    ObserversId: observerIds,
  });
  const resp = await adapter.updateTaskObservers(request);
  if (resp.IsSuccess) {
    onSuccessEdit();
  } else {
    onFailEdit(request.Id);
    addNotification('Произошла ошибка при обновлении списка наблюдателей', false);
  }
};

/**Сохранить название задачи */
const saveTaskName = async () => {
  if (!formData.value.Name.trim() || !editTaskInfo.value?.Id) return;
  const request = new TaskUpdateNameModel({
    Id: editTaskInfo.value.Id,
    Name: formData.value.Name,
  });
  const resp = await adapter.updateTaskName(request);
  if (resp.IsSuccess) {
    onSuccessEdit();
  } else {
    onFailEdit(request.Id);
    addNotification('Произошла ошибка при обновлении названия задачи', false);
  }
};

/**Сохранить статус задачи */
const saveTaskStatus = async (statusId: number) => {
  formData.value.StatusId = statusId;
  if (statusId === undefined || !editTaskInfo.value?.Id) return;
  const request = new TaskUpdateStatusModel({
    Id: editTaskInfo.value.Id,
    StatusId: statusId,
  });
  const resp = await adapter.updateTaskStatus(request);
  if (resp.IsSuccess) {
    onSuccessEdit();
  } else {
    onFailEdit(request.Id);
    addNotification('Произошла ошибка при обновлении статуса задачи', false);
  }
};

/**Сохранить приоритет задачи */
const saveTaskPriority = async (priorityId: number) => {
  formData.value.PriorityId = priorityId;
  if (priorityId === undefined || !editTaskInfo.value?.Id) return;
  const request = new TaskUpdatePriorityModel({
    Id: editTaskInfo.value.Id,
    PriorityId: priorityId,
  });
  const resp = await adapter.updateTaskPriority(request);
  if (resp.IsSuccess) {
    onSuccessEdit();
  } else {
    onFailEdit(request.Id);
    addNotification('Произошла ошибка при обновлении приоритета задачи', false);
  }
};

/**Сохранить тип задачи */
const saveTaskType = async (typeId: string) => {
  formData.value.TypeId = typeId;
  if (typeId === undefined || !editTaskInfo.value?.Id) return;
  const request = new TaskUpdateTypeModel({
    Id: editTaskInfo.value.Id,
    TaskTypeId: typeId,
  });
  const resp = await adapter.updateTaskType(request);
  if (resp.IsSuccess) {
    onSuccessEdit();
  } else {
    onFailEdit(request.Id);
    addNotification('Произошла ошибка при обновлении типа задачи', false);
  }
};
/**Сохранить уровень сложности */
const saveTaskDifficulty = async (difficultyId: string) => {
  formData.value.DifficultyId = difficultyId;
  if (difficultyId === undefined || !editTaskInfo.value?.Id) return;
  const request = new TaskUpdateDifficultyModel({
    Id: editTaskInfo.value.Id,
    DifficultyId: difficultyId,
  });
  const resp = await adapter.updateTaskDifficulty(request);
  if (resp.IsSuccess) {
    onSuccessEdit();
  } else {
    onFailEdit(request.Id);
    addNotification('Произошла ошибка при обновлении сложности задачи', false);
  }
};
/**Сохранить дату дедлайна */
const saveDeadline = async (deadlineDate: Date) => {
  if (!deadlineDate) return;
  formData.value.DeadlineDate = deadlineDate;
  if (!editTaskInfo.value?.Id) return;
  const request = new TaskUpdateDateEndModel({
    Id: editTaskInfo.value.Id,
    DateEnd: deadlineDate,
  });
  const resp = await adapter.updateDeadline(request);
  if (resp.IsSuccess) {
    onSuccessEdit();
  } else {
    onFailEdit(request.Id);
    addNotification('Произошла ошибка при обновлении дедлайна задачи', false);
  }
};
/**Сохранить описание */
const saveDescription = async () => {
  if (!editTaskInfo.value?.Id) return;

  const request = new TaskUpdateDescriptionModel({
    Id: editTaskInfo.value.Id,
    Description: formData.value?.Description ?? '',
  });

  const resp = await adapter.updateTaskDescription(request);
  if (resp.IsSuccess) {
    onSuccessEdit();
  } else {
    onFailEdit(request.Id);
    addNotification('Произошла ошибка при обновлении описания задачи', false);
  }
};

/**Установить дефолтные значения */
const setDefaults = () => {
  if (editTaskInfo.value) return;
  const { DefaultStatus, DefaultPriority, DefaultDifficulty, DefaultType } = dictionaries.value;

  formData.value = new TaskFormDataModel({
    ...formData.value,
    StatusId: DefaultStatus?.Id,
    PriorityId: DefaultPriority?.Id,
    DifficultyId: DefaultDifficulty?.Id,
    TypeId: DefaultType?.Id,
  });
};
/**Установить данные перехода */
const setTransferData = (dataTransfer?: TaskFormDataTransferModel) => {
  if (editTaskInfo.value || !dataTransfer) return;

  if (dataTransfer) {
    formData.value = new TaskFormDataModel({
      Name: dataTransfer.Name ?? formData.value.Name,
      Description: dataTransfer.Description ?? formData.value.Description,
      StatusId: dataTransfer.StatusId ?? formData.value.StatusId,
      TypeId: dataTransfer.TypeId ?? formData.value.TypeId,
      PriorityId: dataTransfer.PriorityId ?? formData.value.PriorityId,
      DifficultyId: dataTransfer.DifficultyId ?? formData.value.DifficultyId,
      PerformerIds: dataTransfer.PerformerIds,
      ObserverIds: dataTransfer.ObserverIds,
      DeadlineDate: dataTransfer.DeadlineDate,
      Tags: dataTransfer.Tags,
      FolderId: dataTransfer.FolderId,
      Files: [...dataTransfer.Files],
    });
  }
};

/**Скопировать id задачи */
const copyId = async () => {
  if (!editTaskInfo.value?.Id) return;
  if (await copyToClipboard(editTaskInfo.value.Id)) {
    addNotification('Идентификатор задачи скопирован');
  }
};
/**Скопировать название задачи */
const copyName = async () => {
  if (!editTaskInfo.value?.Name) return;
  if (await copyToClipboard(editTaskInfo.value.Id + ' ' + editTaskInfo.value.Name)) {
    addNotification('Название задачи скопировано');
  }
};

/**Скопировать название и ссылку */
const copyNameAndLinkTask = async () => {
  if (!editTaskInfo.value?.Id) return;

  const route = router.resolve({
    name: 'task-detail',
    params: {
      projectId: props.projectId,
      queueId: props.queueId,
      taskId: editTaskInfo.value.Id,
    },
  });

  if (!route?.href) return;

  const origin =
    window.location.hostname === 'localhost' ? 'https://beta.hub-pm.com' : window.location.origin;

  const link = origin + route.href;
  const textContent = `${editTaskInfo.value.Id} ${editTaskInfo.value.Name}`;

  if (await copyToClipboard(`[${textContent}](${link})`)) {
    addNotification('Название и ссылка тикета скопирована');
  }
};

/**Валидатор */
const { StartValidate, StopValidate, errors, isDisabledSubmit } = useFormValidator(
  computed(() => ({
    Name: formData.value.Name,
  })),
  {
    Name: [FormValidators.required('Название задачи — обязательное поле')],
  },
);

const mainDetailErrors = computed(() => ({
  Name: errors.value?.Name ?? '',
  PerformerIds: '',
}));
/**При обновлении ID задачи */
const onUpdate = async (value1, value2) => {
  isInitLoading.value = true;
  // Был изменен проект
  const isChangedProject = props.projectId !== lastProjectId;
  // Была изменена очередь
  const isChangedQueue = props.queueId !== lastQueueId;
  // Была изменена задача
  const isChangedTask = props.taskId !== editTaskInfo.value?.Id;

  lastQueueId = props.queueId;
  lastProjectId = props.projectId;

  // Если ничего не было изменено
  if (!(isChangedTask || isChangedQueue || isChangedTask)) return;

  reset();

  editTaskInfo.value = new TaskModel({
    Id: props.taskId,
  });

  if (isChangedQueue || isChangedProject) {
    await getDictionaries(props.queueId, props.projectId, props.namespaceId);
  }

  if (props.taskId) {
    await getTaskDetail(props.taskId);

    await Promise.all([initTimerData(), getSubtasks()]);
  } else {
    setDefaults();
  }
  isInitLoading.value = false;
};

const { getFormDataTransfer } = useTaskFormDataTransfer();

watch(() => [props.taskId, props.queueId, props.projectId], onUpdate);

watch(
  () => isUserAccessTask.value,
  () => {
    emit('checkIsUserAccessTask', isUserAccessTask.value);
  },
  { immediate: true },
);

watch(
  () => formData.value,
  () => {
    document.title = formData.value.Name?.slice(0, 30);
  },
);

const parentScrollContainer: string = inject('parent-scroll-container');
const isFixedRightConten = ref<boolean>();

/**Ссылка на модальное окно предупреждения при не сохраненных данных */
const $noSaveDataModal = ref<InstanceType<typeof TaskNoSaveDataModal>>();
/**Функция для перехода на страницу при попытке выхода */
let leaveNext: NavigationGuardNext | undefined;
/**Подтверждение выхода со страницы */
const confirmLeave = async () => {
  if (!leaveNext) return;
  await adapter.unSubscribeToTaskChange(props.taskId);
  // Переход на страницу
  leaveNext();
};
/**Отмена выхода со страницы */
const cancelLeave = () => {
  if (leaveNext) {
    leaveNext(false);
    leaveNext = undefined;
  }
};
/**При попытке выхода */
const onLeave = (next: NavigationGuardNext) => {
  leaveNext = next;
  // Если режим редактирования
  if (!isAllowExit.value) {
    $noSaveDataModal.value?.open();
    return;
  }
  confirmLeave();
};
function changePriority(value: any) {
  addNotification('Приоритет изменен');
  formData.value.PriorityId = value.Value.PriorityId;
}
function changeStatus(value: any) {
  addNotification('Статус изменен');
  formData.value.StatusId = value.Value.StatusId;
}
function changeType(value: any) {
  addNotification('Тип задачи изменен');
  formData.value.TypeId = value.Value.TaskTypeId;
}
function changeDifficulty(value: any) {
  addNotification('Сложность изменена');
  formData.value.DifficultyId = value.Value.DifficultyId;
}
function changeName(value: any) {
  addNotification('Название изменено');
  formData.value.Name = value.Value.Name;
}
function changeDescription(value: any) {
  addNotification('Описание изменено');
  formData.value.Description = value.Value.Description;
}
function changeObserver(value: any) {
  addNotification('Наблюдатели измененены');
  formData.value.ObserverIds = value.Value.Observers.map((x: any) => x.PerformerId);
}
function changeTagsInTask(value: any) {
  addNotification('Тэги измененены');
  formData.value.Tags = value.Value.Tags.map((x: any) => x.Id);
}
function changeDateEnd(value: any) {
  addNotification('Дата окончания изменилвсь');
  formData.value.DeadlineDate = moment(value.Value.DateEnd).tz(moment.tz.guess()).toDate();
}
function changePerformer(value: any) {
  addNotification('Исполнители измененены');
  formData.value.PerformerIds = value.Value.Performers.map((x: any) => x.PerformerId);
}
/** */
function updateTaskFileName(value: any) {
  addNotification('Исполнители измененены');
  formData.value.PerformerIds = value.Value.Performers.map((x: any) => x.PerformerId);
}

function removeTaskEstimatePerformer(value: any) {
  addNotification('Исполнители измененены');
  formData.value.PerformerIds = value.Value.Performers.map((x: any) => x.PerformerId);
}
function changeOrderNumberQueueTask(value: any) {
  addNotification('Очереди измененены');

  formData.value.PerformerIds = value.Value.Performers.map((x: any) => x.PerformerId);
}
async function removeTaskSubtask(value: any) {
  await getSubtasks();
  addNotification('Подзадачи обнавлены');
  // getTaskDetail(editTaskInfo.value.Id);
}
async function attachTaskSubtask(value: any) {
  await getSubtasks();
  addNotification('Подзадачи обнавлены');
  // getTaskDetail(editTaskInfo.value.Id);
}
async function removeTaskQueueRelation(value: any) {
  // await getSubtasks();
  addNotification('Удалена очередь');
  getTaskDetail(editTaskInfo.value.Id);
}
function addTaskQueueRelation(value: any) {
  addNotification('Очередь измененены');
  getTaskDetail(editTaskInfo.value.Id);
}

function addTaskFilesBatch(value: any) {
  addNotification('файлы измененены');
  formData.value.PerformerIds = value.Value.Performers.map((x: any) => x.PerformerId);
}
function addTaskFile(value: any) {
  addNotification('файлы измененены');
  formData.value.PerformerIds = value.Value.Performers.map((x: any) => x.PerformerId);
}
function removeTaskFiles(value: any) {
  addNotification('файлы измененены');
  formData.value.PerformerIds = value.Value.Performers.map((x: any) => x.PerformerId);
}
function listenCompleteAddFile(value: any) {
  addNotification('файлы измененены');
}

function removeTaskFilesEvent(value: any) {
  addNotification('файлы измененены');
}
onBeforeMount(async () => {
  await getAccessCurrentUserInQueueTask();
});
onUnmounted(() => {
  adapterListen.UnListenAll();
  channelStopTimer.close();
});

onMounted(async () => {
  isInitLoading.value = true;
  if (route.query?.isOpenCreateSubtask) {
    $taskDrawer.value?.open(
      new TaskDrawerSettingsModel({
        Mode: 'create-subtask',
        ParentTaskId: props.taskId,
      }),
    );
  }

  lastQueueId = props.queueId;
  lastProjectId = props.projectId;

  channelStopTimer.onmessage = () => {
    stopTimer();
  };
  if (!route.query.tab || isNaN(Number(route.query.tab))) {
    router.replace({
      query: {
        tab: 0,
      },
    });
  }

  await getDictionaries(props.queueId, props.projectId, props.namespaceId);

  if (props.taskId) {
    await getTaskDetail(props.taskId);
    await Promise.all([initTimerData(), getSubtasks()]);
  } else {
    setDefaults();
    prevFormDataJsonString.value = JSON.stringify(formData.value);
    setTransferData(getFormDataTransfer());
  }
  const x = await accessAdapter.getUserAccess({ QueueTaskId: props.queueId });
  const id = CurrentUser.Id;
  const isIAutor = formData.value?.Owner?.Id == id;
  editing.value = (Boolean(x.Value) || isIAutor) && !props.isEstimate;

  document.querySelector(parentScrollContainer)?.addEventListener('scroll', (e: Event) => {
    let parentContainerScrollTop: HTMLElement = e.target as HTMLElement;
    isFixedRightConten.value = parentContainerScrollTop.scrollTop > 45;
  });

  isInitLoading.value = false;

  emit('updateLoading', isInitLoading.value);
});

watch(
  () => route.query,
  () => {
    const tab = Number(route.query.tab);
    currentTabId.value = isNaN(tab) ? 0 : tab;
  },
  { deep: true },
);

onBeforeMount(async () => {
  await adapter.subscribeToTaskChange(props.taskId);
});

onBeforeRouteLeave((to, from, next) => {
  onLeave(next);
});
</script>

<style lang="scss" scoped>
@keyframes skeleton-loading {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

.project-tasks-layout {
  position: relative;
  overflow: hidden;

  &__main-skeleton {
    height: 75rem;
    border-radius: 0.5rem 0.5rem 0rem 0rem;
    background-color: var(--neutral-10, #eaeaeb);
  }

  &__main-content-skeleton {
    display: grid;
    margin-top: 1.313rem;
    width: 100%;
    gap: 0.75rem;
    grid-template-columns: minmax(0, 1fr) 27.5rem;
  }

  &__main-right-skeleton {
    border-radius: 0.5rem 0.5rem 0rem 0rem;
    height: 75rem;
    background-color: var(--neutral-10, #eaeaeb);
  }

  &__main-skeleton::before,
  &__main-content-skeleton::before,
  &__main-right-skeleton::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: skeleton-loading 1.5s infinite;
  }
}

.task-detail {
  display: grid;
  width: 100%;
  gap: 0.75rem;
  grid-template-columns: minmax(0, 1fr) 27.5rem;
  position: relative;

  &__section {
    background-color: var(--neutral-0, #ffffff);
    border-radius: 0.5rem;
    max-height: calc(100vh - 9rem);
    height: fit-content;
    min-width: 0;
    box-shadow: 0rem 0rem 0.063rem 0rem #0000000a, 0rem 0.25rem 0.5rem 0rem #0000000a;
    height: calc(100vh - 9.5rem);
    overflow: hidden;

    &.right {
      display: flex;
      position: sticky;
      top: 1rem;
      flex-direction: column;
      transition: 0.3s;
      height: calc(100vh - 9.5rem);
      // min-height: calc(100vh - 9.189rem);
      // max-height: calc(100vh - 9.189rem);
      width: 27.5rem;
      overflow: hidden;
    }
  }

  &__sidebar {
    height: 100%;
  }

  &__section-right-tabs {
    padding-top: 1.5rem;
    margin: 0 1.5rem 0 1.5rem;
  }

  &__section-right--fixed {
    height: calc(100vh - (3.563rem + 1.313rem + 1.313rem)) !important;
    min-height: calc(100vh - (3.563rem + 1.313rem + 1.313rem)) !important;
    max-height: calc(100vh - (3.563rem + 1.313rem + 1.313rem)) !important;
  }

  &__section-right-tabs-content {
    margin: 0 1.5rem 0 1.5rem;
  }

  &__section-right-tabs-content-first {
    padding-top: 1.5rem;

    padding-bottom: 1.5rem;
  }
}
</style>
